import { createHashHistory } from 'history';
import { Route, Router, Switch } from 'react-router-dom';
import { DonationSurveyContainer } from '../DonationSurvey';
import { EventCheckIn } from '../EventCheckIn';
import { CustomSurvey } from '../SurveyResponses/Custom/containers/CustomSurvey';
import { RegisterForEvent } from '../SurveyResponses/EventRegistration/containers/RegisterForEvent';
import { SatisfactionSurveyResponseSubmitted } from '../SurveyResponses/Satisfaction/components/SatisfactionSurveyResponseSubmitted';
import { TakeSurvey } from '../SurveyResponses/Satisfaction/containers/TakeSurvey';
import { SupportRating } from '../SupportRating';
import { SurveyUnavailable } from '../SurveyUnavailable';

const AppHashHistory = createHashHistory();

export const SurveysRouter = () => {
	return (
		<Router history={AppHashHistory}>
			<Switch>
				<Route path='/support-rating/:ratingToken'>
					<SupportRating />
				</Route>
				<Route path='/survey/unavailable'>
					<SurveyUnavailable />
				</Route>
				<Route path='/survey/:token?/submitted'>
					<SatisfactionSurveyResponseSubmitted />
				</Route>
				<Route path='/survey/:token?'>
					<TakeSurvey />
				</Route>
				<Route path='/event/:eventId/check-in'>
					<EventCheckIn />
				</Route>
				<Route path='/event/:token?'>
					<RegisterForEvent />
				</Route>
				<Route path='/custom-survey/:token?'>
					<CustomSurvey />
				</Route>
				<Route path='/donation/:token?'>
					<DonationSurveyContainer />
				</Route>
			</Switch>
		</Router>
	);
};
